import produce from 'immer';
import {
    SET_SELECTED_PLAN, SET_SEED_HISTORY, SET_SEED_REQUESTING, SET_SEARCH_TEXT, SET_SEED_DETAIL, SET_SELECTED_IDS, SET_FILTERED_SEED_HISTORY,
    SET_SEED_SUPPLIER_DETAILS, SET_SEED_VARIETY_DETAILS, REMOVE_SEED_LOADS, UPDATE_SEED_LOAD, SET_BULK_EDIT, SET_SELECTED_SEED_LOAD_ID, SET_EDITED_SEED_HISTORY, UPDATE_PAYLOAD, SET_SEED_DISCARD, SET_ALL_PLAN, SET_SEED_TIMELINE, SET_SEED_TIMELINE_REQUESTING,
    SET_SEED_LOT_DETAILS, SET_SEED_TARE_LOAD_REQUESTING, SET_SEED_TARE_LOAD, UPDATE_SEED_TARE_LOAD, SET_SEED_TYPE_DETAILS, SET_SEED_CUTTING_GROUP
} from '../constants/action-types';

const initialState = {
    selectedPlanType: 10,
    isSelectAllPlan: false,
    searchText: "",
    seedHistory: {
        isRequesting: false,
        payload: [],
        data: [],
        totalCapacity: 0,
        totalCount: 0,
        seedSupplier: [],
        seedVariety: [],
        seedLot: [],
        seedType: [],
        seedCuttingGroup: [],
        enableBulkEdit: false,
        selectedLoads: [],
        seedTimeLine: {
            isRequesting: false,
            data: [],
        },
        filterIds: {
            crew_uuid: [],
            field_geo_shape_uuid: [],
            variety_name: [],
            supplier: [],
            seed_lot: [],
            seed_type: [],
            seed_cutting_group: [],
            target_equipment_group_uuid: [],
            source_equipment_group_uuid: [],
            offload_geo_shape_uuid: [],
            storage_geo_shape_uuid: [],
            pipe: [],
            target_equipment_vendor_id: [],
            crop_name: [],
            load_capacity: [],
            load_seconds: [],
            approved: []
        }
    },
    tareLoadHistory: {
        isRequesting: false,
        data: [],
        loadDetails: {
            totalCount: 0,
            totalCapacity: 0,
            totalLoadSeconds: 0
        },
        totalLoadTripCount: 0
    }
};

export default (state = initialState, action) => {
    switch (action.type) {
        case SET_SELECTED_PLAN:
            state = { ...state, selectedPlanType: action.payload };
            break;

        case SET_ALL_PLAN:
            state = { ...state, isSelectAllPlan: action.payload };
            break;

        case SET_SEARCH_TEXT:
            state = { ...state, searchText: action.searchText };
            break;

        case SET_SEED_REQUESTING:
            state = { ...state, seedHistory: { ...state.seedHistory, isRequesting: true } };
            break;

        case SET_SEED_SUPPLIER_DETAILS:
            state = { ...state, seedHistory: { ...state.seedHistory, seedSupplier: action.payload } };
            break;

        case SET_SEED_VARIETY_DETAILS:
            state = { ...state, seedHistory: { ...state.seedHistory, seedVariety: action.payload } };
            break;

        case SET_SEED_LOT_DETAILS:
            state = { ...state, seedHistory: { ...state.seedHistory, seedLot: action.payload } };
            break;

        case SET_SEED_DETAIL:
            const { totalCapacity = 0, totalCount = 0 } = action.payload;
            state = { ...state, seedHistory: { ...state.seedHistory, totalCapacity, totalCount } };
            break;

        case SET_SELECTED_IDS:
            state = { ...state, seedHistory: { ...state.seedHistory, filterIds: action.payload } };
            break;

        case SET_BULK_EDIT:
            state = { ...state, seedHistory: { ...state.seedHistory, enableBulkEdit: action.payload } };
            break;

        case SET_SELECTED_SEED_LOAD_ID:
            state = { ...state, seedHistory: { ...state.seedHistory, selectedLoads: action.payload } };
            break;

        case SET_FILTERED_SEED_HISTORY:
            state = {
                ...state,
                seedHistory: {
                    ...state.seedHistory,
                    isRequesting: false,
                    data: { ...state.seedHistory.data, history: action.payload },
                }
            };
            break;

        case SET_EDITED_SEED_HISTORY:
            const { updatedLoad } = action.payload;
            state = {
                ...state,
                seedHistory: {
                    ...state.seedHistory,
                    isRequesting: false,
                    data: { ...state.seedHistory.data, history: updatedLoad },
                }
            };
            break;

        case SET_SEED_HISTORY:
            state = {
                ...state,
                seedHistory: {
                    ...state.seedHistory,
                    isRequesting: false,
                    payload: action.payload,
                    data: action.payload,
                }
            };
            break;

        case UPDATE_SEED_LOAD:
            const loadId = action.loadId;
            const data = action.data
            const seedHistoryData = state.seedHistory.data.history ? state.seedHistory.data.history : [];
            const loadIndex = seedHistoryData.findIndex(e => e.load_activity_uuid === loadId);
            if (loadIndex === -1) break;
            seedHistoryData[loadIndex] = {
                ...seedHistoryData[loadIndex],
                ...data
            }
            state = {
                ...state,
                seedHistory: {
                    ...state.seedHistory,
                    data: {
                        ...state.seedHistory.data,
                        history: seedHistoryData
                    },
                }
            };
            break;

        case REMOVE_SEED_LOADS:
            const loadDeleteId = action.payload;
            const seedHistory = state.seedHistory.data.history ? state.seedHistory.data.history : [];
            const removedLoads = [];
            if (!Array.isArray(loadDeleteId) || loadDeleteId.length === 0) break;
            for (const load of seedHistory) {
                if (!loadDeleteId.includes(load.load_activity_uuid)) {
                    removedLoads.push(load)
                }
            }
            state = {
                ...state,
                seedHistory: {
                    ...state.seedHistory,
                    data: {
                        ...state.seedHistory.data,
                        history: removedLoads
                    },
                }
            };
            break;

        case SET_SEED_DISCARD:
            state = {
                ...state,
                seedHistory: {
                    ...state.seedHistory,
                    data: state.seedHistory.payload,
                    selectedLoads: []
                }
            };
            break;

        case UPDATE_PAYLOAD:
            state = {
                ...state,
                seedHistory: {
                    ...state.seedHistory,
                    payload: state.seedHistory.data,
                    selectedLoads: []
                }
            };
            break;

        case SET_SEED_TIMELINE_REQUESTING:
            state = {
                ...state,
                seedHistory: {
                    ...state.seedHistory,
                    seedTimeLine: {
                        data: [],
                        isRequesting: true
                    }
                }
            };
            break;

        case SET_SEED_TIMELINE:
            state = {
                ...state,
                seedHistory: {
                    ...state.seedHistory,
                    seedTimeLine: {
                        data: action.payload,
                        isRequesting: false
                    }
                }
            };
            break;

        case SET_SEED_TARE_LOAD_REQUESTING:
            state = produce(state, s => {
                s.tareLoadHistory.isRequesting = true;
                s.tareLoadHistory.data = [];
                s.tareLoadHistory.loadDetails = initialState.tareLoadHistory.loadDetails;
            });
            break;


        case SET_SEED_TARE_LOAD: {
            const { payload } = action;

            if (!payload) {
                state = produce(state, s => {
                    s.tareLoadHistory = initialState.tareLoadHistory;
                });

                break;
            }

            const loadDetails = {
                totalCount: payload.load.total_count,
                totalCapacity: payload.load.total_capacity,
                totalLoadSeconds: payload.load.total_load_seconds
            }

            state = produce(state, s => {
                s.tareLoadHistory.isRequesting = false;
                s.tareLoadHistory.data = payload.history;
                s.tareLoadHistory.loadDetails = loadDetails;
            });
            break;
        }
        case UPDATE_SEED_TARE_LOAD: {
            const { payload } = action;
            const { updatedData, updatedLoadCapacity } = payload

            if (!updatedData || !updatedLoadCapacity) {
                state = produce(state, s => {
                    s.tareLoadHistory = initialState.tareLoadHistory;
                });

                break;
            }

            state = produce(state, s => {
                s.tareLoadHistory.data = updatedData;
                s.tareLoadHistory.loadDetails.totalCapacity = updatedLoadCapacity;
            });
            break;
        }
        case SET_SEED_TYPE_DETAILS: {
            state = { ...state, seedHistory: { ...state.seedHistory, seedType: action.payload } };
            break;
        }
        case SET_SEED_CUTTING_GROUP: {
            state = { ...state, seedHistory: { ...state.seedHistory, seedCuttingGroup: action.payload } };
            break;
        }
        default:
            break;
    }

    return state;
};